import { type PropertyValue } from 'api/clients/PropertyClient'
import { Checkbox } from 'components/Form/Checkbox/Checkbox'
import Styles from '../PropertyValue.module.scss'
import { Property, PropertyValue as PropertyValueType } from 'api/clients/PropertyClient'

interface Props {
  propertyValue?: PropertyValue
  onCreate: (propertyValue: PropertyValueType) => void
  onDelete: (propertyValue: PropertyValueType) => void
  property: Property
}

const CheckboxEdit = ({ propertyValue, onCreate, onDelete, property }: Props) => {
  const handleOnChange = () => {
    if (propertyValue) return onDelete(propertyValue)

    onCreate({
      value: '',
      property_id: property.id,
    } as PropertyValueType)
  }

  return (
    <div className={Styles.checkboxContainer}>
      <Checkbox
        aria-label="Edit Checkbox Property"
        isSelected={!!propertyValue}
        onChange={() => handleOnChange()}
        size="md"
        variant="primary"
        disableFocus
      />
    </div>
  )
}

export default CheckboxEdit
